/**
 * Stepper horizontal compacto do fluxo de criação de pedido.
 * Só a etapa atual mostra o rótulo (as demais ficam como círculos com
 * tooltip), então a barra cabe em uma linha em qualquer largura.
 * Etapas concluídas são clicáveis para voltar.
 * steps: [{ key, label }] — key é o índice interno do wizard.
 */
const WizardStepper = ({ steps, currentStep, onStepClick }) => (
    <ol className="mb-6 flex flex-nowrap items-center justify-center overflow-x-auto" aria-label="Progresso da criação de pedido">
        {steps.map((step, index) => {
            const done = step.key < currentStep;
            const current = step.key === currentStep;
            return (
                <li key={step.key} className="flex shrink-0 items-center">
                    {index > 0 ? (
                        <span aria-hidden="true" className={`mx-1 h-px w-3 sm:w-6 ${done || current ? "bg-primary" : "bg-primary/30"}`}></span>
                    ) : null}
                    <button
                        type="button"
                        disabled={!done}
                        onClick={() => done && onStepClick(step.key)}
                        aria-current={current ? "step" : undefined}
                        title={done ? `Voltar para ${step.label}` : step.label}
                        className={`group flex items-center gap-1.5 rounded-full px-0.5 py-0.5 ${done ? "cursor-pointer" : "cursor-default"}`}
                    >
                        <span
                            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition ${
                                current
                                    ? "border-primary bg-primary text-black"
                                    : done
                                        ? "border-primary bg-mgs-elevated text-primary group-hover:bg-primary group-hover:text-black"
                                        : "border-primary/30 bg-mgs-surface text-laranjinha/40"
                            }`}
                        >
                            {done ? "✓" : index + 1}
                        </span>
                        {current ? (
                            <span className="whitespace-nowrap text-sm font-semibold text-laranjinha">{step.label}</span>
                        ) : null}
                    </button>
                </li>
            );
        })}
    </ol>
);

export default WizardStepper;
